import { Component, ViewChild, ViewContainerRef } from "@angular/core"
import { CtrlBaseComponent } from '../ctrl-base.component';
import { Color } from "../../enums/color.enum";

@Component({
  selector: "ct-content-item",
  templateUrl: "./ct-content-item.component.html",
  styleUrls: ["ct-content-item.component.css"],
  host: {
    '[id]': 'getId()',
    '[hidden]': 'getHidden()',
    '[class]': '"content-item-padding " + getStyleClass()'
  }
})
export class CtContentItemComponent extends CtrlBaseComponent {

  @ViewChild('target', { read: ViewContainerRef }) target: ViewContainerRef;
  private title: string;
  private titleComplement: string;
  private icon: string;
  private color : Color;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    this.paintChildren(this.getMetaData(), this.target);
  }

  getTitle(): string { return this.title }
  getIcon(): string { return this.icon }
  getColor(): Color { return this.color }
  getTitleComplement(): string { return this.titleComplement }
  setTitle(title: string): void { this.title = title }
  setIcon(icon: string): void { this.icon = icon }
  setColor(color: Color): void { this.color = color }
  setTitleComplement(titleComplement: string): void { this.titleComplement = titleComplement }
}
